import { Address, erc4626Abi } from "viem"

import { IS_MEZO_MAINNET } from "../network"

const mainnetAddress: Address = "" as Address
const testnetAddress: Address = "0x36C3Fa448A798c602ab8a67721534685fe543146"

const address = IS_MEZO_MAINNET ? mainnetAddress : testnetAddress

const abi = erc4626Abi

export default {
  address,
  abi,
}
